import styled from 'styled-components';

export const NotificationDescription = styled.div.withConfig({
  shouldForwardProp: (prop) => !['notRead'].includes(prop),
})`
  position: relative;
  padding: 16px 24px 16px 48px;
  background-color: ${(props) =>
    props.notRead
      ? props.theme.colors.notificationNotRead
      : props.theme.colors.white};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.bgSecondary};
  }

  .info-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  .action {
    color: ${(props) => props.theme.colors.focusSelect};
  }

  .date {
    margin-left: auto;
    color: ${(props) => props.theme.colors.textSecondary};
  }
`;

export const NotificationContent = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  width: 100%;
  height: 100%;
  max-height: 760px;
  overflow-y: auto;

  & > ${NotificationDescription}:not(:first-child) {
    border-top: 1px solid ${(props) => props.theme.colors.gray};
  }
`;

export const Status = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-left: -15px;
  margin-right: 5px;
  background-color: ${(props) => props.theme.colors.link};
`;

export const NotificationLabel = styled.div`
  width: 100%;
  min-height: 16px;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;

  div:first-child {
    font-weight: bold;
    margin-bottom: 5px;
    color: ${(props) => props.theme.colors.title};
  }

  div:last-child {
    color: ${(props) => props.theme.colors.textPrimary};
  }
`;
